import { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function useAktualitasokEnabled() {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE}/settings/public`)
      .then((res) => (res.ok ? res.json() : { aktualitasokPageEnabled: true }))
      .then((data) => {
        if (!cancelled) {
          setEnabled(data.aktualitasokPageEnabled !== false);
        }
      })
      .catch(() => {
        if (!cancelled) setEnabled(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { enabled, loading };
}
